import { apiRequest } from "../api";

export const getBanners = () => apiRequest("/banners", "GET");
export const saveBanner = (endpoint: string, method: string, payload: unknown) =>
  apiRequest(endpoint, method, payload);
export const deleteBanner = (id: string) => apiRequest(`/banners/${id}`, "DELETE");
